<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
       {{ $t('checklist.hide_items') }}
      </h5>
    </template>

    <template #body>
      <form>
        <div class='modal-body'>
          <div class="form-group">
            <p>{{ $t('checklist.modifying_items', { count: checklistItems.length }) }}</p>
          </div>
        </div>

        <div class='modal-footer'>
          <button type='submit' class="btn btn-outline-primary float-right" @click.prevent="hide">
            {{ $t('checklist.save') }}
          </button>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import modal from "../_modal"

  export default {
    components: {
      modal,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        checklistItems: [],
      }
    },
    computed: {
      checklistItemIds() {
        return this.checklistItems.map(c => c.id)
      },
      hasHiddenChecklist() {
        return this.checklistItems.some(ci => !ci.shared)
      },
    },
    methods: {
      open(checklistItems) {
        this.checklistItems = checklistItems
        this.$refs.modal.open()
      },
      hide() {
        this.store.executeBulkOperation('hide', this.checklistItemIds, { shared: this.hasHiddenChecklist }).then(() => {
          this.store.sendMetrics({name: 'bulk_hide_operation', params: this.$route.params, path: this.$route.fullPath})
          this.$refs.modal.close()
          this.$emit('success')
          this.$toastr.success(this.$t('checklist.processing_checklist'))
        })
      },
    },
  }
</script>
